import React, { useEffect } from "react";
import {
  getDocDataSnap,
  deleteDocById,
  setDocData,
  getAllDocsSnap,
} from "../../../utils/firebase/Firebase.utils";
import InputBox from "../Components/InputBox";
import Select from "react-select";
import toast from "react-hot-toast";
import {
  departmentOptions as departments,
  userRoles,
} from "../../../utils/EleghoUtils";
import {
  FaUser,
  FaEnvelope,
  FaBuilding,
  FaUserTag,
  FaHome,
  FaEdit,
  FaTrash,
  FaSave,
  FaTimes,
} from "react-icons/fa";
import { unitNumberLabel } from "../../../utils/constants";

function UserDetails({ id, setViewMode }) {
  const [formData, setFormData] = React.useState({});
  const [user, setUser] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(true);
  const [disabled, setDisabled] = React.useState(true);
  const [editMode, setEditMode] = React.useState(false);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [residentOptions, setResidentOptions] = React.useState([]);

  useEffect(() => {
    const fetchUser = async () => {
      const user = await getDocDataSnap("users", id, (user) => {
        setUser(user);
        setFormData(user);
        setIsLoading(false);
      });
    };
    fetchUser();
  }, []);

  //get all residents
  useEffect(() => {
    const fetchResidents = async () => {
      const residents = getAllDocsSnap("residents", (residents) => {
        const options = residents.map((resident) => {
          return {
            value: resident.identifier,
            label: resident.owner1 + " " + resident.identifier,
          };
        });
        setResidentOptions(options);
      });
    };
    fetchResidents();
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[300px]">
        <div className="animate-pulse text-[#363062] font-medium">
          Loading...
        </div>
      </div>
    );
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const options = userRoles;

  const departmentOptions = departments;

  const handleEdit = () => {
    setEditMode(!editMode);
    setDisabled(!disabled);
  };

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      await deleteDocById("users", id);
      toast.success("User deleted successfully");
    }
    setViewMode(false);
  };

  const handleUpdate = async () => {
    setIsProcessing(true);
    await setDocData("users", id, formData);
    setIsProcessing(false);
    setEditMode(false);
    setDisabled(true);
    toast.success("User updated successfully");
  };

  const handleSelect = (selectedOption, name) => {
    let arrayValues = [];
    selectedOption.map((option) => {
      arrayValues.push(option.value);
    });
    setFormData({ ...formData, [name]: arrayValues });
  };

  // Custom styles for React Select
  const customSelectStyles = {
    control: (base) => ({
      ...base,
      border: "1px solid #e2e8f0",
      borderRadius: "0.375rem",
      minHeight: "38px",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #8FCD00",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#363062"
        : state.isFocused
        ? "#f0f4f8"
        : null,
      color: state.isSelected ? "white" : "#333",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#f0f4f8",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#363062",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#363062",
      ":hover": {
        backgroundColor: "#8FCD00",
        color: "white",
      },
    }),
  };

  return (
    <div className="w-full max-w-[400px] bg-white rounded-xl shadow-md overflow-hidden mx-auto my-auto flex flex-col">
      {/* Header */}
      <div className="bg-[#363062] text-white p-4 flex justify-between items-center">
        <div className="font-medium text-base">User Details</div>
        <button
          onClick={() => setViewMode(false)}
          className="text-white hover:text-[#8FCD00] transition-colors"
          aria-label="Close"
        >
          <FaTimes />
        </button>
      </div>

      {/* Action buttons */}
      <div className="flex items-center justify-between p-4 border-b border-gray-100">
        <button
          className="flex items-center text-sm text-[#363062] hover:text-[#8FCD00] transition-colors"
          onClick={handleEdit}
        >
          {editMode ? (
            <FaTimes className="mr-1" />
          ) : (
            <FaEdit className="mr-1" />
          )}
          {editMode ? "Cancel" : "Edit"}
        </button>
        <button
          className="flex items-center text-sm text-red-500 hover:text-red-700 transition-colors"
          onClick={handleDelete}
        >
          <FaTrash className="mr-1" />
          Delete
        </button>
      </div>

      {/* Form */}
      <div className="p-4 space-y-4">
        <div className="relative">
          <div className="flex items-center mb-1">
            <FaUser className="text-[#363062] mr-2 text-xs" />
            <label className="text-[#363062] text-xs uppercase font-medium">
              Name
            </label>
          </div>
          <InputBox
            name="displayName"
            value={formData.displayName}
            onChange={handleChange}
            disabled={disabled}
            className="w-full"
          />
        </div>

        <div className="relative">
          <div className="flex items-center mb-1">
            <FaEnvelope className="text-[#363062] mr-2 text-xs" />
            <label className="text-[#363062] text-xs uppercase font-medium">
              Email
            </label>
          </div>
          <InputBox
            name="email"
            value={formData.email}
            onChange={handleChange}
            disabled={disabled}
            className="w-full"
          />
        </div>

        {/* department */}
        {/* <div className="relative">
          <div className="flex items-center mb-1">
            <FaBuilding className="text-[#363062] mr-2 text-xs" />
            <label className="text-[#363062] text-xs uppercase font-medium">
              Department
            </label>
          </div>
          <Select
            options={departmentOptions}
            value={
              formData.department &&
              departmentOptions.find(
                (option) => option.value === formData.department
              )
            }
            onChange={(value) =>
              setFormData({ ...formData, department: value.value })
            }
            isDisabled={disabled}
            styles={customSelectStyles}
          />
        </div> */}

        <div className="relative">
          <div className="flex items-center mb-1">
            <FaUserTag className="text-[#363062] mr-2 text-xs" />
            <label className="text-[#363062] text-xs uppercase font-medium">
              Roles
            </label>
          </div>
          <Select
            options={options}
            isMulti
            value={
              formData.roles &&
              formData.roles.map((role) => {
                return options.find((option) => option.value === role);
              })
            }
            onChange={(selectedOption) => handleSelect(selectedOption, "roles")}
            isDisabled={disabled}
            styles={customSelectStyles}
          />
        </div>

        <div className="relative">
          <div className="flex items-center mb-1">
            <FaHome className="text-[#363062] mr-2 text-xs" />
            <label className="text-[#363062] text-xs uppercase font-medium">
              {unitNumberLabel}
            </label>
          </div>
          <Select
            options={residentOptions}
            isMulti
            value={
              formData.linkedIdentifiers &&
              formData.linkedIdentifiers.map((value) => {
                return residentOptions.find((option) => option.value === value);
              })
            }
            onChange={(selectedOption) =>
              handleSelect(selectedOption, "linkedIdentifiers")
            }
            isDisabled={disabled}
            styles={customSelectStyles}
          />
        </div>

        {editMode && (
          <div className="pt-4">
            <button
              className="w-full bg-[#363062] hover:bg-[#2a254b] text-white py-2 px-4 rounded-md flex items-center justify-center transition-colors"
              onClick={handleUpdate}
              disabled={isProcessing}
            >
              {isProcessing ? (
                <span className="animate-pulse">Processing...</span>
              ) : (
                <>
                  <FaSave className="mr-2" />
                  Save Changes
                </>
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserDetails;
